import OneDynamicComponent from "./components/OneDynamicComponent";
import OneStillComponent from "./components/OneStillComponent";
import TextAndUnderlineComponent from "./components/TextAndUnderlineComponent";
import TextAndInlineUnitComponent from "./components/TextAndInlineUnitComponent";

import "./style.css"; // Importing the CSS file
import UpperTextLeftAnchor from "./components/UpperTextLeftAnchor";
import UpperTextRightAnchor from "./components/UpperTextRightAnchor";
import UpperTextMiddleAnchor from "./components/UpperTextMiddleAnchor";

// values for the dynamic components

const BATTERIEPercentage = Array.from({ length: 10 }, (_, i) => `./images/BATTERIE/Batterie-${10 - i}.png`);

const BMS_BAT_TEMP = Array.from(
  { length: 37 },
  (_, i) => `./images/BMS_BAT_TEMP1/BMS_Batterie_T_droite-${37 - i}.png`
);

const BMS_INT_TEMP = Array.from(
  { length: 37 },
  (_, i) => `./images/BMS_BAT_TEMP1/BMS_Internal_Temp-${37 - i}.png`
);

const BRAKE = Array.from({ length: 15 }, (_, i) => `./images/BRAKE/Brake-${15 - i}.png`);

const THROTTLE = Array.from({ length: 15 }, (_, i) => `./images/THROTTLE/Trottle-${15 - i}.png`);

function Overlay({
  throttle_percent,
  brake_percent,
  BATTERIE_level,
  speed,
  bms_bat_temp1,
  bms_bat_temp2,
  bms_int_temp1,
  bms_int_temp2,
  motor_temp,
  controller_temp,
  voltage,
  player_first_name,
  player_surname,
  lap_fastest,
  lap_current,
  lap_total,
}) {


  function formatLapTime(lapFastest) {
    //convert milliseconds into the formated time required by the our beautifull UI/UX design Alexandre
    const minutes = Math.floor(lapFastest / 60000);
    const seconds = Math.floor((lapFastest % 60000) / 1000);
    const milliseconds = lapFastest % 1000;

    // Pad the seconds and milliseconds with leading zeros if necessary
    const formattedMinutes = minutes.toString();
    const formattedSeconds = seconds.toString().padStart(2, "0");
    const formattedMilliseconds = milliseconds.toString().padStart(3, "0");


    return `${formattedMinutes}:${formattedSeconds}:${formattedMilliseconds}`;
  }

  let lap_fastest_txt = "--:--:--";
  if (lap_fastest > 0)
    lap_fastest_txt = formatLapTime(lap_fastest)

  return (
    <div className="overlayMainDiv">

      {/* Fixed background image */}
      <div
        className="fullscreen-image"
        style={{
          backgroundImage: `url("./images/FOND_OVERLAY/fond.png")`,
          zIndex: 0,
        }}
      ></div>

      {/* Fixed images, non dynamic*/}
      <OneStillComponent imagePath={"./images/LIGNE/ligne_style_inf.png"} />

      {lap_current > 0 && lap_total > 0 && (
        <OneStillComponent imagePath={"./images/PARTIE-HAUTE/number_lap.png"} />
      )}

      <OneStillComponent imagePath={"./images/PARTIE-HAUTE/name_pilote.png"} />
      <OneStillComponent imagePath={"./images/LOGO_RAGE/rage.png"} />

      <OneStillComponent imagePath={"./images/BMS_BAT_TEMP1/BMS_Batterie_T_droite-37.png"} />
      <OneStillComponent imagePath={"./images/BMS_BAT_TEMP1/BMS_Internal_Temp-37.png"} />

      {/* Fixed images used to limit flickering*/}

      <OneStillComponent imagePath={"./images/BATTERIE/Batterie-10.png"} />
      <OneStillComponent imagePath={"./images/BRAKE/Brake-15.png"} />
      <OneStillComponent imagePath={"./images/THROTTLE/Trottle-15.png"} />

      {/* Dynamic images, takes a value as input*/}
      <OneDynamicComponent
        valueLevel={Math.max(1, Math.floor(Math.min(Math.max(BATTERIE_level, 0), 100) / 10))}
        imageArray={BATTERIEPercentage}
      />
      <OneDynamicComponent
        valueLevel={Math.min(
          36,
          Math.max(
            1,
            Math.floor((Math.min(Math.max(bms_bat_temp1, 0), 85) / 85) * 37),
            Math.floor((Math.min(Math.max(bms_bat_temp2, 0), 85) / 85) * 37)
          )
        )}
        imageArray={BMS_BAT_TEMP}
      />
      <OneDynamicComponent
        valueLevel={Math.min(
          36,
          Math.max(
            1,
            Math.floor((Math.min(Math.max(bms_int_temp1, 0), 85) / 85) * 37),
            Math.floor((Math.min(Math.max(bms_int_temp2, 0), 85) / 85) * 37)
          )
        )}
        imageArray={BMS_INT_TEMP}
      />
      <OneDynamicComponent
        valueLevel={Math.floor((Math.min(Math.max(brake_percent, 0), 100) / 100) * 14) + 1}
        imageArray={BRAKE}
      />
      <OneDynamicComponent
        valueLevel={Math.floor((Math.min(Math.max(throttle_percent, 0), 100) / 100) * 14) + 1}
        imageArray={THROTTLE}
      />

      {/* Dynamic text with units under, takes a value as input*/}
      <TextAndUnderlineComponent
        value={Math.max(speed, 0)}
        unit="KM/H"
        posx={50}
        posy={85}
        fontSizeValue={109}
        fontSizeUnit={30}
        gap={5}
      />
      <TextAndUnderlineComponent
        value={Math.max(voltage, 0)}
        unit="V"
        posx={33.3}
        posy={83.9}
        fontSizeValue={51}
        fontSizeUnit={32}
        gap={10}
      />
      <TextAndUnderlineComponent
        value={`${Math.min(Math.max(motor_temp, 0), 170)}\u00B0`}
        posx={67.5}
        posy={83.5}
        fontSizeValue={30}
        fontSizeUnit={25}
        underline={false}
      />
      <TextAndUnderlineComponent
        value={`${Math.min(Math.max(controller_temp, 0), 100)}\u00B0`}
        posx={65.5}
        posy={88}
        fontSizeValue={30}
        fontSizeUnit={25}
        underline={false}
      />

      {/* Dynamic text with units to the right, takes a value as input*/}
      <TextAndInlineUnitComponent
        value={`${Math.min(Math.max(throttle_percent, 0), 100)}%`}
        text={"THROTTLE"}
        posx={29.05}
        posy={82}
        fontSize={13}
      />
      <TextAndInlineUnitComponent
        value={`${Math.min(Math.max(brake_percent, 0), 100)}%`}
        text={"BRAKE"}
        posx={29}
        posy={86.3}
        fontSize={13}
      />
      <TextAndInlineUnitComponent
        value={`${Math.max(Math.max(bms_int_temp1, 0), Math.max(bms_int_temp2, 0))}°`}
        text={"BMS INTERNAL T°"}
        underScoreOrTwoDots={false}
        posx={48.7}
        posy={75.5}
        fontSize={13}
      />
      <TextAndInlineUnitComponent
        value={`${Math.max(Math.max(bms_bat_temp1, 0), Math.max(bms_bat_temp2, 0))}°`}
        text={"BMS BATTERY TEMPS"}
        underScoreOrTwoDots={false}
        posx={61.4}
        posy={75.5}
        fontSize={13}
      />

      {/* Upper Dynamic text with no units, takes a value as input and expand to the right (left fixed) when text increases*/}
      <UpperTextLeftAnchor
        text={player_first_name}
        text2={player_surname.toUpperCase()}
        posx={37.7}
        posy={5}
        fontSize={32}
        textColor={"white"}
      />

      {/* Upper Dynamic text with no units, takes a value as input and expand to the left (right fixed) when text increases*/}
      <UpperTextRightAnchor text={"FASTEST LAP"} posx={37.5} posy={5} fontSize={18} textColor={"white"} />

      <UpperTextRightAnchor
        text={lap_fastest_txt}
        posx={37.5}
        posy={8.9}
        fontSize={32}
        textColor={"white"}
      />

      {lap_current > 0 && lap_total > 0 && (
        <UpperTextMiddleAnchor
          text={`Lap ${lap_current}/ ${lap_total}`}
          posx={50.0}
          posy={17}
          fontSize={18}
          textColor={"white"}
        />
      )}
    </div>
  );
}

export default Overlay;
